<svelte:options customElement="hb-input-select" />

<script lang="ts">
  /**
   * Svelte Input Select WebComponent
   * =====================
   *
   * @contributors: Dario Caruso <dev@dariocaruso.info> (https://dariocaruso.info)
   *
   * @license: MIT License
   *
   */

  import type { FormSchemaEntry, Component } from "./types/webcomponent.type";

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }
  let {
    schemaentry = undefined, // Rinomina per evitare conflitti con la versione elaborata

    show_validation = "no", // Default a "no"
    id = undefined, // Default a undefined
  }: Component = $props();

  let options: { value: string; label?: string; id: string }[] = $derived(
    schemaentry?.params?.options ?? [],
  );
  let valid = $derived.by(() =>
    !schemaentry?.required || value ? true : false,
  );

  let value: string | undefined = $state(undefined);

  $effect(() => {
    if (schemaentry && typeof schemaentry === "string") {
      try {
        schemaentry = JSON.parse(schemaentry as unknown as string);
      } catch (err) {}
      value = schemaentry?.value as string;
    }

    if (schemaentry?.id) {
      id = schemaentry.id;
    }
  });
  $effect(() => {
    dispatch("setVal", { value, valid, id: id });
  });
</script>

{#if typeof schemaentry === "object"}
  <select
    bind:value
    class="form-control {show_validation === 'yes' && schemaentry?.required
      ? valid
        ? 'is-valid'
        : 'is-invalid'
      : ''}"
    id={schemaentry?.id}
    required={schemaentry?.required}
    readonly={schemaentry?.readonly}
  >
    {#each options as option (option.id)}
      <option value={option.value} selected={value === option.value}
        >{option.label ?? option.value}</option
      >
    {/each}
  </select>

  {#if schemaentry?.validationTip && show_validation === "yes"}
    <div part="invalid-feedback" class="invalid-feedback mb-1">
      {schemaentry.validationTip}
    </div>
  {/if}
{/if}

<style lang="scss">
  @forward "./styles/bootstrap.scss";
  @forward "./styles/webcomponent.scss";
</style>
